import { render, staticRenderFns } from "./rating-carousel.vue?vue&type=template&id=0af8f457"
import script from "./rating-carousel.vue?vue&type=script&lang=js"
export * from "./rating-carousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./rating-carousel.vue?vue&type=custom&index=0&blockType=graphql"
if (typeof block0 === 'function') block0(component)

export default component.exports